module.exports = __webpack_public_path__ + "static/media/highway_out@3x.9b3e8520.png";